<template>
  <div class="$style.open_layout">
    <app-header
      :has-login="false"
      :show-menu="false"
      :enableRedirectToTop="false"
    >
    </app-header>
    <div :class="$style.open_content">
      <div :class="$style.open_content_body">
        <div :class="$style.wrapper">
          <section :class="$style.container">
            <h1 :class="$style.head_section">
              <img :class="$style.logo" src="@/assets/images/open_logo.svg" />
            </h1>
            <p :class="$style.title_section">
              {{ getTitle }}
            </p>
            <div :class="$style.maintenance_notice">
              <div :class="$style.maintenance_text">
                <!-- 文中の改行はPCだけ。スマホでは画面幅で自然に折り返す -->
                <p>
                  平素より「くみあいアプリ」をご利用いただき、誠にありがとうございます。
                </p>
                <p>
                  2026年10月21日に公表されたPHPの重大な脆弱性への対応として、<br
                    :class="$style.pc"
                  />「くみあいアプリ」のサービスを停止しておりました。
                </p>
                <p>
                  その後、サービス再開に向けた対応について慎重に検討を重ねてまいりましたが、<br
                    :class="$style.pc"
                  />「くみあいアプリ」のサービス提供を断念することといたしました。
                </p>
                <p>
                  それに伴い、お客様の組合活動への影響を可能な限り軽減するため、<br
                    :class="$style.pc"
                  />代替サービスをご用意しております。<br
                    :class="$style.pc"
                  />突然のご案内となりますことを心よりお詫び申し上げます。
                </p>
                <p>
                  詳細は下記ページをご覧ください。<br />
                  <a
                    href="https://www.j-union.net/notice/20261030-info.php"
                    target="_blank"
                    rel="noopener noreferrer"
                    >https://www.j-union.net/notice/20261030-info.php</a
                  >
                </p>
                <p>
                  これまで『くみあいアプリ』をご愛顧いただきましたこと、心より御礼申し上げます。
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
      <app-footer />
    </div>
  </div>
</template>
<script>
import AppHeader from '@/components/app/AppOpenHeader/AppOpenHeader'
import AppFooter from '@/components/app/AppFooter/AppFooter'
export default {
  components: { AppHeader, AppFooter },
  props: {},
  data: function () {
    return {}
  },
  methods: {},
  computed: {
    getTitle() {
      return '「くみあいアプリ」サービス提供終了のお知らせ'
    },
  },
}
</script>
<style lang="scss" module>
.open_content {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 90px);
  background: $keyYellow;
}
.open_content_body {
  display: flex;
  flex: 1;
  background: url('~@/assets/images/open_top_bg.svg') repeat;
  background-position: -30px -150px;
  background-attachment: fixed;
}
.wrapper {
  color: $keyBlack;
  text-align: left;
  margin: 0 auto;
  box-sizing: border-box;
  width: 1080px;
  padding: 34px 82px;

  @include mobile() {
    width: 375px;
    padding: 42px 32px;
  }

  * {
    margin: 0;
    padding: 0;
  }

  .pc {
    @include mobile() {
      display: none !important;
    }
  }
  .sp {
    @include pc() {
      display: none !important;
    }
  }

  .container {
    display: flex;
    align-items: center;
    flex-direction: column;

    .head_section {
      display: flex;
      align-items: center;
      font-size: 29px;
      font-weight: bold;
      margin-bottom: 24px;
      flex-direction: column;

      @include pc() {
        font-size: 45px;
        margin-bottom: 35px;
      }

      .logo {
        width: 95px;
        @include mobile() {
          width: 64px;
          margin-bottom: 4px;
        }
      }
    }
    .title_section {
      font-size: 20px;
      line-height: 30px;
      font-weight: bold;
      margin-bottom: 0px;
      display: flex;
      justify-content: center;

      @include pc() {
        font-size: 30px;
        line-height: 48px;
        text-align: center;
        margin-bottom: 0px;
      }
      &.status {
        margin-top: 20px;
        margin-bottom: 10px;
      }
    }
    .message_section {
      font-size: 16px;
      line-height: 30px;
      font-weight: bold;
      color: #707070;
      display: flex;
      justify-content: center;
      width: 100%;
      margin: 20px auto 40px;

      @include mobile() {
        font-size: 12px;
        line-height: 24px;
        margin-bottom: 40px;
        width: 280px;
      }
      a {
        color: $keyGreen;
        font-size: 16px;
        font-weight: 400;
        cursor: pointer;
        text-decoration: underline;
        @include mobile() {
          font-size: 11px;
        }
      }
    }

    .maintenance_notice {
      width: 100%;
      max-width: 760px;
      margin-top: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      .maintenance_text {
        color: #383838;
        font-size: 16px;
        line-height: 1.9;
        padding: 20px;
        width: 100%;
        box-sizing: border-box;
        text-align: center;

        @include mobile() {
          font-size: 13px;
          line-height: 1.8;
          padding: 0;
        }

        p + p {
          margin-top: 1.2em;
        }
        a {
          color: $keyGreen;
          text-decoration: underline;
          word-break: break-all;
        }
      }
    }
  }
}
</style>
